module.exports = __webpack_public_path__ + "15bf8d7ba38c09ca1f75f7125b18b620.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-reggae-s.png
// module id = 2282
// module chunks = 0